import FetchUtils from '../utils/fetch.utils';

export default class OnboardingService {
  static BASE_URL = `${process.env.PREACT_APP_API_DOMAIN_ONBOARDING}/api/onboarding`;

  static getStatus = async organizationCode => {
    return FetchUtils.get(
      `${OnboardingService.BASE_URL}/status` +
        FetchUtils.getQueryParams({ organization: organizationCode }),
    );
  };

  static getData = async () => {
    return FetchUtils.get(`${OnboardingService.BASE_URL}/form`);
  };

  static saveForm = async (organizationCode, data) => {
    const body = {
      onboardingFormData: data,
    };

    const url =
      `${OnboardingService.BASE_URL}/form` +
      FetchUtils.getQueryParams({
        organization: organizationCode,
      });

    return FetchUtils.post(url, body);
  };
}
